import styled from "styled-components";
// 페이지 안 섹션 바로가기 탭 (스크롤 따라 상단에 붙음). inSection[i]가 참이면 i번째 탭을 진하게
const SectionTabs = styled.div`
  position: sticky;
  z-index: 2;
  top: calc(${({ theme }) => theme.layout.header} + 0.75rem);
  align-self: center;
  display: flex;
  gap: 0.25rem;
  margin-top: 3rem;
  padding: 0.35rem;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(8px);
  border: 1px solid ${({ theme }) => theme.colors.line};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  & a {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    cursor: pointer;
    border-radius: 999px;
    padding: ${({ breakpoints }) => (breakpoints?.md ? "0.6rem 1.5rem" : "0.5rem 0.9rem")};
    font-size: ${({ breakpoints }) => (breakpoints?.md ? "1rem" : "0.85rem")};
    font-weight: 700;
    color: ${({ theme }) => theme.colors.foreground.dimmed};
    transition: background-color 0.2s, color 0.2s;
    &:hover {
      color: ${({ theme }) => theme.colors.accent};
    }
    ${({ inSection = [], theme }) =>
      inSection
        .map((on, i) =>
          on ? `&:nth-child(${i + 1}) { background-color: ${theme.colors.dark}; color: white; }` : ""
        )
        .join("\n")}
  }
`;
export default SectionTabs;
